export default __webpack_public_path__ + "static/media/11.ed8ea9a9.png";